module.exports = __webpack_public_path__ + "static/media/right-arrow.32ca2d48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/right-arrow.svg
// module id = 238
// module chunks = 0